import { render, staticRenderFns } from "./PopupSignedDocumentList.vue?vue&type=template&id=dc637f4e&scoped=true"
import script from "./PopupSignedDocumentList.vue?vue&type=script&lang=js"
export * from "./PopupSignedDocumentList.vue?vue&type=script&lang=js"
import style0 from "./PopupSignedDocumentList.vue?vue&type=style&index=0&id=dc637f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc637f4e",
  null
  
)

export default component.exports